<div class="message-notifications">
  @for (toast of wsToasts; track toast.title + toast.body; let i = $index) {
    <div class="message-notifications__item" (click)="removeWsToast($event, i)">
      <div class="message-notifications__item__title">{{ toast.title }}</div>
      <div class="message-notifications__item__info">
        <div class="message-notifications__item__info__text">{{ toast.body }}</div>
      </div>
      <button type="button" class="close-btn" (click)="removeWsToast($event, i)" aria-label="Закрыть">×</button>
    </div>
  }
</div>
